import { createTRPCReact, httpBatchLink } from '@trpc/react-query';
import superjson from 'superjson';
import { supabase } from '@/lib/supabase';
import { readImpersonation } from '@/lib/impersonation';
import type { AppRouter } from '@server/trpc/router';

export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      transformer: superjson,
      async headers() {
        const { data } = await supabase.auth.getSession();
        const token = data.session?.access_token;
        const headers: Record<string, string> = {};
        if (token) headers.authorization = `Bearer ${token}`;
        const imp = readImpersonation();
        if (imp) headers['x-impersonate-as'] = imp.targetUserId;
        return headers;
      },
    }),
  ],
});
